export default __webpack_public_path__ + "static/shop-new-arrivals-mobile-1f0a7a79acc19949e4ec73a7e12426d4.webp";